import { render, staticRenderFns } from "./AddSpecialPriceModal.vue?vue&type=template&id=471ad656&scoped=true&"
import script from "./AddSpecialPriceModal.vue?vue&type=script&lang=js&"
export * from "./AddSpecialPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSpecialPriceModal.vue?vue&type=style&index=0&id=471ad656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ad656",
  null
  
)

export default component.exports